// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__jvLOL","alertIcon":"ConfirmModal_alertIcon__3z_e-"};